var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-avatar',{attrs:{"size":"30px","color":"grey"}},[_c('v-img',{attrs:{"src":require('../assets/avatar.png'),"alt":"user"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }